module.exports = __webpack_public_path__ + "assets/img/kuozhan.f628da28.png";